import {Constants} from '../constants';
import {Links} from '../links';
import {FlowableLinkConstants} from '../flowable/flowable-link-constants';

export class SentryConstants {

  private static readonly OFFER_CASE: string = [
    Links.INSURER_LINK_URL,
    FlowableLinkConstants.FLW_LINK_ENTRYPOINT_OFFER_LANDING_PAGE_CASE,
  ].join(Constants.SLASH);

  public static readonly OPAQUE_ROUTES_MOST_SPECIFIC_FIRST: ReadonlyArray<string> = [
    `/${Links.IFRAME_LINK_URL}/broker/:key`,
    `/${Links.IFRAME_LINK_URL}/inter-pension/:key`,
    `/${Links.IFRAME_LINK_URL}/:key`,
    '/api-platform/iframes/:key',
    `/${Links.SHARED_LINK_URL}/insurer-interview/:hash`,
    `/${Links.CRM_LINK_URL}/${Links.CLIENT_DETAILS_URL}/${Links.EDIT_URL}/:type/:clientId`,
    `/${Links.SOBRADO_CONNECT_LINK_URL}/transaction/:transactionId/request/:id`,
    `/${Links.SOBRADO_CONNECT_LINK_URL}/transaction/:transactionId`,
    `/${Links.CUSTOMIZED_EXCEL_LINK_URL}/:id/edit`,
    `/${Links.PPL_LINK_URL}/:id/edit`,
    `/${Links.PPL_LINK_URL}/:id/report`,
    `/${Links.SOBRADO_UNDERWRITING_LINK_URL}/audit/event/:id`,
    `/${Links.BROKER_LINK_URL}/call/:caseInstanceId`,
    `/${Links.SBS_LINK_URL}/${Links.PROCESS_LINK_URL}/:caseInstancesId`,
    `/${Links.SBS_LINK_URL}/${Links.NEW_VERSION_LINK_URL}/:caseInstancesId`,
    `/${Links.LINK_CALL_API_PROCESS}/:callProcessId/${Links.PROCESS_LINK_URL}/:caseInstancesId`,
    `/${this.OFFER_CASE}/:caseId/${FlowableLinkConstants.FLW_LINK_TASK}/:taskId`,
    `/${this.OFFER_CASE}/:caseId`,
    `/${Links.POLICY_LINK_URL}/policy-process/:callCaseInstanceId/:offerCaseInstanceId`,
    `/${Links.POLICY_LINK_URL}/:policyCaseId/edit`,
    `/${Links.TEST_LINK_URL}/delete-policy-example/:policyId`,
  ];

  public static readonly OIDC_CALLBACK_PATH: string = `/${Links.LINK_OIDC_CALLBACK}`;

  public static readonly ROUTE_PARAM_SEGMENT: string = '[^/?#\\s]+';

  public static readonly ROUTE_SEGMENT_END: string = '(?=[/?#\\s]|$)';

  public static readonly PREFIXED_ENGINE_ID: RegExp = /\/[A-Z]{3}-[^/?#\s]+/g;

  public static readonly UUID: RegExp = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

  public static readonly NUMERIC_SEGMENT: RegExp = /\/\d+(?=\/|$)/g;

  public static readonly QUERY_OR_FRAGMENT: RegExp = /[?#]/;

  public static readonly ELEMENT_ID: RegExp = /#\S+/g;

  public static readonly ID_PLACEHOLDER: string = ':id';

  public static readonly SPAN_URL_ATTRIBUTES: ReadonlyArray<string> = [
    'url', 'http.url', 'url.full', 'url.path', 'code.filepath', 'lcp.url', 'browser.web_vital.lcp.url', 'transaction',
  ];

  public static readonly SPAN_QUERY_ATTRIBUTES: ReadonlyArray<string> = [
    'http.query', 'http.fragment', 'url.query', 'url.fragment',
  ];

  public static readonly SPAN_SELECTOR_ATTRIBUTE: RegExp = /^(browser\.web_vital\.)?(lcp\.element|cls\.source\.\d+)$/;

  public static readonly SELECTOR_NAMED_SPAN_OP: RegExp = /^ui\.(interaction|webvital)\./;

  public static readonly SELECTOR_BREADCRUMB_CATEGORY_PREFIX: string = 'ui.';

  public static readonly BREADCRUMB_URL_FIELDS: ReadonlyArray<string> = ['from', 'to', 'url'];

  public static readonly TRANSACTION_SOURCE_URL: string = 'url';

  public static readonly TRANSACTION_EVENT_TYPE: string = 'transaction';

}
